import backendURL from "./config";

export const addBlogAPI = async (
  category,
  mediaURLs,
  heading,
  writtenBy,
  htmlContent
) => {
  try {
    const response = await backendURL.post("blog/register", {
      category,
      mediaURLs,
      heading,
      writtenBy,
      htmlContent,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error adding to Blog:", error);
    throw error;
  }
};

export const editBlogAPI = async (
  id,
  category,
  heading,
  writtenBy,
  htmlContent,
  mediaURLs
) => {
  try {
    const response = await backendURL.post("blog/update", {
      id,
      category,
      heading,
      writtenBy,
      htmlContent,
      mediaURLs,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error adding to gallery:", error);
    throw error;
  }
};

export const deleteBlogAPI = async (id) => {
  try {
    const response = await backendURL.post("blog/delete", {
      id,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding to gallery:", error);
    throw error;
  }
};

export const viewBlog = async (page, pageSize) => {
  try {
    const response = await backendURL.post("blog/view", {
      page,
      pageSize,
    });
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to fetch categories"
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("Something went wrong. Please try again.");
    }
  }
};

export const viewAllBlog = async (category) => {
  try {
    const response = await backendURL.post("blog/viewBlogByCategory", {category});
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to fetch categories"
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("Something went wrong. Please try again.");
    }
  }
};

export const viewTodayBlog = async () => {
  try {
    const response = await backendURL.get("blog/viewLatestBlog");
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to fetch categories"
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("Something went wrong. Please try again.");
    }
  }
};
